import { useLocation, useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { toast } from 'react-hot-toast';
import Api from '../../../utils/Api';
import StepWizard from '../../../components/StepWizard';
import CreateList from './CreateListStep';
import AddExternalList from './AddExternalListStep';
import Done from './DoneStep';

const styles = css`
display: flex;
flex-wrap: wrap;
flex-direction: column;
width: 100%;
max-width: 400px;
margin: auto;
align-content: center;
text-align: center;
gap: 20px;
margin-top: 5vh;
& .steps {
  & .step {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    width: 100%;

    & .buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      width: 100%;
    }
  }
}
`;

const ListsNew = styled(({ className }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { group } = state ?? {};
  const onDone = async list => {
    if (group) {
      const [error,] = await Api.shareList({ groupId: group._id, listId: list._id })
      if (error) {
        console.error(error);
        toast.error(Api.error(error))
      }
      else {
        navigate(`/lists/details/${list._id}?context=group&id=${group._id}`, { replace: true });
      }
    } else {
      navigate(`/lists/details/${list._id}`, { replace: true });
    }
  }

  const onCancel = () => navigate(-1);

  return (
    <div className={className}>
      <StepWizard className='steps' onDone={onDone} onCancel={onCancel}>
        <CreateList />
        <AddExternalList />
        <Done />
      </StepWizard>
    </div>
  )

})`${styles}`;

export default ListsNew;
